import React, { useEffect, useState } from "react";
import axios from "axios";
import { environmentalURL } from "../environmentalURL";

function PhishingReport() {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [allResponse, countResponse] = await Promise.all([
        axios.get(
          `${environmentalURL}/api/phishing/all`
        ),
        axios.get(
          `${environmentalURL}/api/phishing/count`
        ),
      ]);

      setData(allResponse.data);
      setCount(countResponse.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        background: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Count Card */}
      <div
        style={{
          background: "#1976d2",
          color: "#fff",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ margin: 0 }}>
          Total Click Count
        </h2>

        <h1
          style={{
            marginTop: "10px",
            fontSize: "40px",
          }}
        >
          {count}
        </h1>
      </div>

      {/* Table */}
      <div
        style={{
          background: "#fff",
          borderRadius: "10px",
          padding: "15px",
          boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h2>Phishing Awareness Click Report</h2>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr
              style={{
                background: "#1976d2",
                color: "#fff",
              }}
            >
              <th style={thStyle}>ID</th>
              <th style={thStyle}>Clicked Time</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td style={tdStyle}>
                  {row.id}
                </td>

                <td style={tdStyle}>
                  {new Date(
                    row.clickedAt
                  ).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const thStyle = {
  padding: "12px",
  textAlign: "left",
};

const tdStyle = {
  padding: "12px",
  borderBottom: "1px solid #ddd",
};

export default PhishingReport;